/* eslint-disable no-alert */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';

function Listings(props) {
  const history = useHistory();
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [signal, setSignal] = useState(0);

  const editListing = (ent) => {
    history.push(`/listings/edit/${ent.id}`);
  };

  const deleteListing = async (listing, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-restricted-globals
    const cnfrm = confirm(props.t(`Are you sure you want to delete ${listing.sku}?`));

    if (cnfrm) {
      try {
        await post(url.DELETE_LISTING, { id: listing.id });

        toastr.success(`Deleted listing ID: ${listing.id}`, 'Success');
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Listings')}</CardTitle>

                <Can i="see" this="Listings">
                  <BaseGrid
                    url={url.GET_LISTINGS}
                    hasSearch
                    create="/listings/create"
                    shouldUpdate={signal}
                    className="table table-sm table-hover table-bordered fs-6 listings-grid-table"
                    config={
                    {
                      columns: {
                        thumb: {
                          label: '',
                          image: {
                            src: (listing) => (`/api/listings/thumbnail/${listing.id}`),
                            class: 'rounded',
                            style: { maxHeight: '6rem', maxWidth: '6rem' },
                          },
                          translate: false,
                        },
                        id: {
                          label: 'ID',
                          sort: true,
                          style: { minWidth: '100px' },
                          link: {
                            to: '/listing/%id%',
                          },
                          html: true,
                          format: (x, lst) => {
                            if (lst.last_qty > 0) {
                              // In Stock
                              return `<span class="badge bg-success"><span class="mdi mdi-check"></span></span> &nbsp;${x}`;
                            }

                            // OOS
                            return `<span class="badge bg-warning bg-soft"><span class="mdi mdi-close-thick text-dark"></span></span> &nbsp;${x}`;
                          },
                        },
                        sku: {
                          label: 'Sku',
                          sort: true,
                        },
                        title: { label: 'Title', sort: true, style: { fontSize: '11px', maxWidth: '200px' } },
                        condition: { label: 'Condition', sort: true, style: { fontSize: '11px' } },
                        price: {
                          label: 'Price',
                          sort: false,
                          format: (x) => new Intl.NumberFormat(
                            'en-US',
                            {
                              style: 'currency',
                              currency: 'USD',
                            },
                          ).format(x),
                          style: { fontSize: '11px' },
                        },
                        last_qty: {
                          label: 'Qty for Sale',
                          sort: true,
                          style: { fontSize: '11px' },
                        },
                        created_at: {
                          label: props.t('Created'),
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                          sort: true,
                          style: { fontSize: '11px' },
                        },
                        tags: {
                          label: 'Tags',
                          format: (x) => (x.map((r) => (r.label))),
                          badges: {
                            class: 'bg-info bg-soft text-dark p-1',
                          },
                        },
                        channels: {
                          label: 'Channels',
                          format: (x) => (x.map((r) => (r.channel))),
                          badges: {
                            class: 'bg-light text-dark p-1',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Edit'),
                              click: editListing,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteListing,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Listings"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Listings.defaultProps = {
  t: (x) => (x),
};

Listings.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Listings));
